// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';

export class ProjectStatus {
  readonly id: string;
  readonly name: string;
  readonly priority: number;
  readonly isArchived: boolean;
  readonly systemBehavior: Enums.ProjectStatusSystemBehavior;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.priority = data.priority === undefined ? 0 : data.priority;
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
    this.systemBehavior =
      data.systemBehavior === undefined
        ? Enums.ProjectStatusSystemBehavior.Custom
        : data.systemBehavior;
  }

  static zero(): ProjectStatus {
    const zeroValues: ExcludeMethodsDeep<ProjectStatus> = {
      id: NIL_UUID,
      name: '',
      priority: 0,
      isArchived: false,
      systemBehavior: Enums.ProjectStatusSystemBehavior.Custom,
    };
    return new ProjectStatus(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ProjectStatusWireFormat = {
  id: string;
  name: string;
  priority: number;
  isArchived: boolean;
  systemBehavior: string;
};

type NewProjectStatusProps = PartialDeep<ProjectStatus, { recurseIntoArrays: true }>;
export const NewProjectStatus: (props: NewProjectStatusProps) => ProjectStatus = (props) =>
  new ProjectStatus(props);

type NewProjectStatusFromWireFormatProps = PartialDeep<
  ProjectStatusWireFormat,
  { recurseIntoArrays: true }
>;
export const NewProjectStatusFromWireFormat: (
  props: NewProjectStatusFromWireFormatProps,
) => ProjectStatus = (props) => new ProjectStatus(props);
